export default {

    // SETTERS
    setInitialState({commit}, {caseId, clientId, taggingItem}) {
        commit('RESET_STATE');
        commit('SET_CASE_ID', Number.parseInt(caseId));
        commit('SET_CLIENT_ID', clientId);
        commit('SET_TAGGING_ITEM', taggingItem);
        commit('SET_TAGGING_MODE', true);
    },
    setTaggingItem({commit}, item) {
        commit('SET_TAGGING_ITEM', item);
    },
    setClientId({commit}, clientId) {
        commit('SET_CLIENT_ID', clientId);
    },
    setDeviceInfo({commit}, device) {
        commit('SET_DEVICE_INFO', device);
    },
    setClientInfo({commit}, client) {
        commit('SET_CLIENT_INFO', client);
    },
    setTaggingMode({commit}, isTaggingActive) {
        commit('SET_TAGGING_MODE', isTaggingActive);
    },
    setLoadingState({commit}, isLoading) {
        commit('SET_LOADING_STATE', isLoading);
    },
};